<template>
  <v-data-table
    v-bind="$attrs"
    style="cursor: pointer"
    :items="tankRecordings"
    :headers="headers"
    :group-by="showGroup ? 'tank.tankName' : null"
    sort-by="statusDateTimeLt"
    sort-desc
    :items-per-page="-1"
    :mobile-breakpoint="dataTableMobileBreakpoint"
    @click:row="handleRowClick"
  >
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-ferry</v-icon>{{ title }}
        </span>
        <v-spacer></v-spacer>
        <v-switch
          dense
          class="my-0"
          v-model="showGroup"
          :label="'Show tank group'"
          color="tertiary"
        />
      </div>
    </template>
    <template v-slot:group.header="props">
      <td
        class="text-start pa-2 font-weight-medium"
        :colspan="props.headers.length"
      >
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-car-coolant-level</v-icon>
              {{ props.group }}
            </span>
          </template>
          Tank: {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.quantityOnBoard="{ item }">
      <span>{{ `${item.quantityOnBoard} ${item.tank.qtyUom}` }}</span>
    </template>
    <template v-slot:item.statusDateTimeLt="{ item }">
      <span>{{ item.statusDateTimeLt | removeTAndSecondsAndFormatDate }}</span>
    </template>
    <template v-slot:item.fillLevel="{ item }">
      <TablePercentageBar
        :value="item.fillPercent"
        :color="getProgressColourByFillPercent(item.fillPercent)"
      />
    </template>
  </v-data-table>
</template>

<script>
import TablePercentageBar from '../ui/TablePercentageBar.vue';
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import TankStatusMixin from '../../mixins/TankStatusMixin';

export default {
  name: 'DailyTankReportRecordingsTable',
  inheritAttrs: false,
  mixins: [TankStatusMixin, ResponsiveSizeHelperMixin],
  components: { TablePercentageBar },
  props: {
    title: {
      type: String,
      required: true,
    },
    tankRecordings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Tank', value: 'tank.tankName' },
        { text: 'Status Date (Lt)', value: 'statusDateTimeLt' },
        { text: 'Bulk', value: 'bulk' },
        { text: 'Quantity', value: 'quantityOnBoard' },
        { text: 'Fill Level', value: 'fillLevel' },
        { text: 'Specific Gravity', value: 'specificGravity' },
      ],
      showGroup: true,
    };
  },
  methods: {
    handleRowClick(item) {
      if (item.tank) {
        this.goToTankDetails(item.tank);
      }
    },
  },
};
</script>
